import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChatMessage } from '@models/chat-message.interface';
import { IconComponent } from '@shared/icon/icon.component';
import { ChatEmotePipe } from '@shared/pipes/chat-emote.pipe';
import { NamePipe } from '@shared/pipes/name.pipe';

@Component({
  selector: 'app-chat-system-message',
  templateUrl: './chat-system-message.component.html',
  styleUrls: ['./chat-system-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'type',
  },
  imports: [IconComponent, ChatEmotePipe, NamePipe],
})
export class ChatSystemMessageComponent implements OnChanges {
  @Input() message: ChatMessage;
  @Input() type: 'pinned' | 'default' | 'green' | 'red' | 'yellow' | any = 'default';
  content = '';

  ngOnChanges() {
    if (!this.message) {
      return;
    }

    this.content = this.message.content as string;
  }
}
